import { useFormContext } from "react-hook-form";
import { SupportThreadFormSchema } from "../support-form-helpers";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";

const CounterContainer = styled(Box)`
  position: absolute;
  z-index: 1;
  opacity: 0.5;
`;

const Text = styled(Typography)`
  font-size: ${(p) => p.theme.text.fontSizes.s};
  color: ${(p) => p.theme.text.colors.secondary};
`;

interface Props {
  maxLength: number;
  right?: string;
  left?: string;
  top?: string;
  bottom?: string;
}

export const CharacterCounter = (props: Props) => {
  const { maxLength, ...rest } = props;
  const { watch } = useFormContext<SupportThreadFormSchema>();

  const description = watch("description");

  return (
    <CounterContainer sx={{ ...rest }}>
      <Text>
        {description.length} / {maxLength}
      </Text>
    </CounterContainer>
  );
};
